<template>
<div id="ccLogin">

  <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

  <div class="container">
  <div class="row">
  <div class="col-md-4 offset-md-4" style="border:10px solid #171a26; background:rgba(19,21,31,0.7); margin-top:50px; padding:50px 0 50px 0; border-radius: 15px;">

    <section v-show="tela1">
    <div class="row">
    <div class="col-md-10 offset-md-1">

        <p class="text-center">
          <img :src='"../../assets/image/logo_sokker.png"' alt="Responsive image" :title='"sokkerduel"' width="180px">
        </p>

        <div v-show="box_alert" class="mt-5 mb-4">
          <div class="alert alert-danger alert-dismissible fade show text-center" role="alert">
            <strong>{{this.box_alert_text}}</strong>
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
        </div>

        <div class="input-group mb-4">
          <the-mask :mask="['###.###.###-##']" masked type="text" v-model="cpf" class="form-control" placeholder="CPF" />
        </div>

        <div class="row">
          <div class="col-12">
            <button type="submit" class="btn w-100 text_15 text_bold mt_5 btn-success" @click="send()">
              REDEFINIR SENHA
            </button>
          </div>
        </div>

        <br><br>

        <p class="text-center"><router-link to="/login" style="color: #fff;">Voltar</router-link></p>

    </div>
    </div>
    </section>

    <section v-show="tela2">
      <div class="row">
        <div class="col-10 offset-1">

          <p class="text-center">
              <img :src='"../../assets/image/logo_sokker.png"' alt="Responsive image" :title='"sokkerduel"' width="180px">
          </p>

          <div class="form-group form-check mb-4 text-white">
            Enviamos um e-mail para <b>{{email}}</b> como as informações para a sua redefinição de senha.
          </div>

          <p class="text-center"><router-link to="/login" style="color: #fff;">Voltar</router-link></p>

        </div>
      </div>
    </section>

  </div>
  </div>
  </div>

</div>
</template>

<script>

var basehost = process.env.BASE_HOST;
var base_url_api = process.env.BASE_URL_API;
import axios from 'axios'
import ccLoading from '../cc_geral/cc_loading.vue'
import Cookies from 'js-cookie'
import { TheMask } from 'vue-the-mask'
import { RouterLink } from 'vue-router';

export default {

  data () {
    return {
      cpf: null,
      email: null,
      tela1: true,
      tela2: false,
      loading: false,
      box_alert: false,
      box_alert_text: null,
    }
  },

  components: { TheMask, ccLoading, RouterLink },

  created()
  {
    localStorage.setItem("base_url_api_mobile", base_url_api);
  },

  methods: {

    async send()
    {

      if(this.cpf == null || this.cpf == ''){
        this.box_alert_text = "CPF não preechido!";
        this.box_alert = true;
        return;
      }

      if( this.validarCPF(this.cpf) == false ){
        this.box_alert_text = "CPF inválido!";
        this.box_alert = true;
        return;
      }

      var body = { cpf: this.cpf, };

      this.loading = true

      axios.post(base_url_api + 'esqueceu/senha', body)
      .then(response => {
        if (response.status === 200) {
          if (response.data.status === 'success') {
            this.email = response.data.email
            this.tela1 = false
            this.tela2 = true
          }
        }

        this.loading = false;
      })
      .catch(error => {

        if (error.response && error.response.status === 400 && error.response.data) {
          let slugValue = error.response.data[0].slug;

          if(slugValue == 'user_not_found') { slugValue = 'CPF não encontrado!'}

          this.box_alert_text = slugValue
          this.box_cor = 0
          this.box_alert = true;
        } else {
          console.log(error.response.status);
        }

        this.loading = false;
      });

    },

  }, //fim do methods


}
</script>


// WEBPACK FOOTER //
// src/components/login/esqueceu_senha.vue